module.exports = __webpack_public_path__ + "static/media/rocket-icon.52fbbe87.svg";